export enum TravelCardType {
    TravelCardN = 'N',
    TravelCardU = 'U',
    TravelCardUTN2 = 'T',
    TravelCardForeign = 'F',
    WalttiCard = 'W',
    Email = 'Q',
    Voucher = 'S',
    Barcode = 'P',
    EstId = 'C',
    TravelCardHSL = 'H',
    BankCard = 'E'
}

export enum TravelCardFullType {
    UTN = 'UTN',
    UID = 'UID',
    FOREIGN = 'FOREIGN'
}

export enum MediumType {
    RelatedCard = 'Related Card',
    TravelCardU = 'Travel Card U',
    TravelCardN = 'Travel Card N',
    TravelCardF = 'Travel Card F',
    TravelCardT = 'Travel Card T',
    TravelCardH = 'Travel Card HSL',
    Email = 'Email',
    Voucher = 'Voucher',
    EstId = 'Estonian ID Card'
}

export enum MediumGroupType {
    Email = 'Email', // has ONLY type Q or ctm 64
    Travelcard = 'Travelcard' // has all travelcards + related cards
}

/**
 * This is used for selection of medium input Email or Travelcard
 * Each group can hold x TravelCardType
 *
 * @export
 * @enum {number}
 */
export class MediumGroup {
    type: MediumGroupType;
    name: string;
    display: string;
    travelcardTypes: TravelCardType[];
    travelcardNumberLength?: number;
    constructor(type: MediumGroupType, name: string, travelcardTypes: TravelCardType[]) {
        this.type = type;
        this.name = name;
        this.display = name;
        this.travelcardTypes = travelcardTypes;
    }
}

export enum RequiredParameterType {
    ACTIVATION = 'ACTIVATION'
}

interface CardTypeMask {
    mask: number;
    name: string;
    medium: MediumGroupType;
    allowedCardTypes: TravelCardType[];
}

interface CardTypeMasksInterface {
    [key: string]: CardTypeMask;
}

export const CardTypeMasks: CardTypeMasksInterface = {
    UID: {
        mask: 1,
        name: 'MEDIUM_UID',
        medium: MediumGroupType.Travelcard,
        allowedCardTypes: [TravelCardType.TravelCardN]
    },
    UTN: {
        mask: 4 | 2048,
        name: 'MEDIUM_UTN_CARD',
        medium: MediumGroupType.Travelcard,
        allowedCardTypes: [TravelCardType.TravelCardU, TravelCardType.TravelCardUTN2]
    },
    PERSON_ID: {
        mask: 8,
        name: 'MEDIUM_PERSON_ID',
        medium: MediumGroupType.Travelcard,
        allowedCardTypes: [TravelCardType.EstId]
    },
    QR: {
        mask: 64,
        name: 'MEDIUM_QR',
        medium: MediumGroupType.Email,
        allowedCardTypes: [TravelCardType.Email]
    },
    MTB: { mask: 512, name: 'MEDIUM_MTB', medium: MediumGroupType.Email, allowedCardTypes: null },
    Foreign: {
        mask: 1024,
        name: 'MEDIUM_FOREIGN',
        medium: MediumGroupType.Travelcard,
        allowedCardTypes: [TravelCardType.TravelCardForeign]
    },
    HSL_MK: {
        mask: 8192,
        name: 'MEDIUM_HSL_MK',
        medium: MediumGroupType.Travelcard,
        allowedCardTypes: [TravelCardType.TravelCardHSL]
    }
};
